<template>
  <v-form
    @submit.prevent="title === 'Crear' ? createadmin() : editadmin()"
    v-model="validation"
    ref="form"
  >
    <v-container>
      <v-row>
        <v-col>
          <Title :title="title + ' admin'" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.firstName"
            type="text"
            label="Nombre"
            class="my-1"
            :rules="rules.default"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.lastName"
            type="text"
            label="Apellido"
            class="my-1"
            :rules="rules.default"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.phone"
            type="text"
            label="Teléfono"
            class="my-1"
            :rules="rules.default"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.email"
            type="text"
            label="Email"
            class="my-1"
            :rules="rules.default"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.password"
            type="text"
            label="Contraseña"
            class="my-1"
            :rules="rules.default"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions class="text--right">
      <v-btn
        small
        color="primary"
        class="pa-5"
        type="submit"
        :disabled="!validation"
        :loading="loading"
      >
        {{ title }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import Title from "../Title.vue";

export default {
  name: "AdminForm",
  components: {
    Title,
  },
  data() {
    return {
      title: "Crear", // Crear | Editar
      form: {
        id: "",
        description: "",
      },
      rules: {
        default: [
          (v) => !!v || "Campo obligatorio",
          (v) => (v && v.length <= 50) || "Debe tener menos de 50 caracteres",
        ],
      },
      loading: false,
      validation: true,
    };
  },
  methods: {
    ...mapMutations(["setAlert", "pushAdmin", "updateAdmin"]),
    setFormValues({ form }) {
      this.form.id = form?.id || null;
      this.form.description = form?.description || "";
    },
    async createadmin() {
      try {
        this.loading = true;
        const res = await axios.post("/api/admin", this.form);
        const { admin } = res.data;
        this.pushAdmin(admin);
        const alert = {
          show: true,
          timeout: 4000,
          color: "success",
          icon: "mdi-check-circle",
          text: "admin creado correctamente",
        };
        this.setAlert(alert);
        this.$emit("created", { item: admin });
        this.$refs.form.reset();
      } catch (error) {
        console.log(error);
        const errorAlert = {
          show: true,
          color: "error",
          timeout: 4000,
          icon: "mdi-alert-remove",
          text: error.respnse.data.message,
        };
        this.setAlert(errorAlert);
      } finally {
        this.loading = false;
      }
    },
    async editadmin() {
      try {
        this.loading = true;
        const res = await axios.put(`/api/admin/${this.form.id}`, this.form);
        const { admin } = res.data;
        this.updateAdmin(admin);
        const alert = {
          show: true,
          color: "dark_primary",
          timeout: 4000,
          icon: "mdi-check-circle",
          text: "admin actualizado correctamente",
        };
        this.setAlert(alert);
        this.$emit("updated", { item: admin });
        this.$refs.form.reset();
      } catch (error) {
        console.log(error);
        const errorAlert = {
          show: true,
          color: "error",
          icon: "mdi-alert-remove",
          text: error.response.data.message,
        };
        this.setAlert(errorAlert);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
